import { AppModal } from '@/shared/ui'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ChangePasswordForm from '../ChangePasswordForm/ChangePasswordForm.container'

interface ChangePasswordModalProps {
  open: boolean
  handleCancel?: () => void
}

const ChangePasswordModal: FC<ChangePasswordModalProps> = ({ open, handleCancel }) => {
  const { t } = useTranslation()
  return (
    <AppModal
      title={t('user-profile.second-table.title')}
      open={open}
      onCancel={handleCancel}
      cancelText={t('cancel')}
      okButtonProps={{ style: { display: 'none' } }}
    >
      <ChangePasswordForm showHeader={false} showFooter={false} />
    </AppModal>
  )
}

export default ChangePasswordModal
